import React, { useState ,useEffect,useMemo } from "react";
//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useCartValidation } from "../../hooks/useCartValidation";

//Import Flatepicker
import Flatpickr from "react-flatpickr";
import {
  Container,
  Alert,
  Form,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  FormFeedback
} from "reactstrap";

import  ZendeskWidget  from "../../Components/CustomerSupport/ZendeskWidget";

//redux
import { useSelector, useDispatch } from "react-redux";


import { createSelector } from 'reselect';
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addCheckOut } from "../../slices/thunks";

import { fetchCartList } from '../../utils/cart';
import { baseURL, submitOrder } from '../../utils/order';
import { addAddress, getAddress, modifyAddress, fetchSavedAddressList, } from '../../utils/addresses';
import { addBillInfo } from '../../utils/order';

import Select from "react-select";
import classnames from "classnames";
import { orderSummary } from "../../common/data/ecommerce";
import { Link } from "react-router-dom";
import { country } from "../../common/data";
import { ToastContainer, toast } from 'react-toastify';
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useStripe } from "@stripe/react-stripe-js";
const CheckOut = () => {
  const [selectedCountry, setselectedCountry] = useState(null);
  const [selectedState, setselectedState] = useState(null);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [modal, setModal] = useState(false);
  const [deletemodal, setDeleteModal] = useState(false);
  const [personalData, setPersonalData] = useState({});
  const [savedAddressList, setSavedAddressList] = useState([]);
  const [stripeId, setStripeId] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState("express"); // Default to express
  const [shippingAddressId, setShippingAddressId] = useState(null);
  const [billingAddressId, setBillingAddressId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [paymentId,setPaymentId] = useState(null);
  const [checkoutStatus,setCheckOutStatus] = useState(false); 
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentInitiated, setPaymentInitiated] = useState(false);

  //add address
  const [selectedAddressCity,setAddressCity] = useState(null);
  const [selectedAddressCountry, setAddressCountry] = useState(null);
  const [selectedAddressType, setAddressTypeValue] = useState(null);


  const [cartData, setproductList] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [dis, setDiscount] = useState(0);
  const [charge, setShippingCharge] = useState(0);
  const [tax, setTax] = useState(0);
  const [stripeUrl,setStripeUrl] = useState(null);
  const [checkoutSessionId ,setCheckoutSessionId] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  
  // Cart validation hook
  const { cartData: validationCartData, loading: cartLoading, hasItems } = useCartValidation();
  
  // const stripePromise = loadStripe("pk_test_51QpEUGG8evvzQwuJIcuwbYrNn94Bmk4iakdmdywniMlZq72FEnUewiRtiMB6ekRiSQSYM5aBL7xB0UKQuGwyMdta002rvOuEoD");
  const stripePromise = useMemo(() => {
    const stripeKey = "pk_test_51QpEUGG8evvzQwuJIcuwbYrNn94Bmk4iakdmdywniMlZq72FEnUewiRtiMB6ekRiSQSYM5aBL7xB0UKQuGwyMdta002rvOuEoD";
    console.log('Loading Stripe with key:', stripeKey.substring(0, 20) + '...'); // ✅ Debug logging
    return loadStripe(stripeKey);
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status"); // Extract productId from query params
  const urlOrderId = searchParams.get("order_id"); // Extract order_id from query params 
  
  useEffect(() => {
    // Listen for Stripe payment completion messages
    const handleStripeMessage = (event) => {
      // Only log important messages to reduce noise
      if (event.origin === 'https://js.stripe.com' && event.data) {
        // Look for payment completion indicators
        if (event.data.type === 'stripe_checkout_session_complete' || 
            event.data.type === 'payment_success' ||
            event.data.type === 'checkout_complete' ||
            (event.data.req && event.data.req.type === 'payment_complete') ||
            (event.data.message && event.data.message.type === 'payment_complete')) {
          console.log('🎉 PAYMENT COMPLETION MESSAGE DETECTED:', event.data);
          // Try to trigger our completion handler
          handleStripePaymentComplete({
            paymentIntent: { id: 'detected_from_message' }
          });
        } else if (event.data.__stripeEmbeddedCheckout && 
                   (event.data.type === 'outer_set_modal' || event.data.type === 'change_iframe_height')) {
          // These are normal Stripe UI messages, don't log them
        } else {
          console.log('Stripe message (checking for completion):', event.data.type || event.data);
        }
      }
    };

    window.addEventListener('message', handleStripeMessage);

    const loadFinish= async () => { 
      if(status==="success"){
        // Get session_id from URL params for verification
        const sessionId = searchParams.get("session_id");
        
        if(sessionId) {
          // Verify payment with backend using session ID
          try {
            console.log('Verifying payment with session ID:', sessionId);
            console.log('Verification URL:', `${process.env.REACT_APP_API_URL}/payment/verify/${sessionId}`);
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/verify/${sessionId}`, {
              headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
              }
            });
            
            console.log('Verification Response Status:', response.status);
            
            if (!response.ok) {
              const errorText = await response.text();
              console.error('Verification API Error:', errorText);
              throw new Error(`Verification failed: ${response.status} - ${errorText}`);
            }
            
            const verificationData = await response.json();
            console.log('Verification Data:', verificationData);
            
            if(verificationData.success && verificationData.payment_status === 'paid') {
              setOrderId(verificationData.order_id);
              setCheckOutStatus(true);
              console.log('Payment verified successfully:', verificationData);
            } else {
              setCheckOutStatus(false);
              errornotify("Payment verification failed. Please contact support.");
              console.error('Payment verification failed:', verificationData);
            }
          } catch (error) {
            console.error('Error verifying payment:', error);
            setCheckOutStatus(false);
            errornotify("Unable to verify payment. Please contact support.");
          }
        } else if(urlOrderId) {
          // Fallback: use order ID from URL if no session ID
          setOrderId(urlOrderId);
          setCheckOutStatus(true);
          console.log('Using order ID from URL (fallback):', urlOrderId);
        } else {
          setCheckOutStatus(false);
          errornotify("Missing payment verification data.");
        }
        
        toggleTab(4);
      }else if(status==="cancel"){
        setCheckOutStatus(false);
        toggleTab(4);
        console.log('Payment cancelled from URL redirect');
      }
    }
    loadFinish();

    return () => {
      window.removeEventListener('message', handleStripeMessage);
    };
     
    },[status,urlOrderId]);

  // Disabled automatic detection - using manual button approach
  // The automatic detection was causing issues due to cross-origin iframe restrictions

  const productState = [
    {
      options: [
        { label: "Select State...", value: "Select State" },
        { label: "Alabama", value: "Alabama" },
        { label: "Alaska", value: "Alaska" },
        { label: "American Samoa", value: "American Samoa" },
        { label: "California", value: "California" },
        { label: "Colorado", value: "Colorado" },
        { label: "District Of Columbia", value: "District Of Columbia" },
        { label: "Florida", value: "Florida" },
        { label: "Georgia", value: "Georgia" },
        { label: "Guam", value: "Guam" },
        { label: "Hawaii", value: "Hawaii" },
        { label: "Idaho", value: "Idaho" },
        { label: "Kansas", value: "Kansas" },
        { label: "Louisiana", value: "Louisiana" },
        { label: "Montana", value: "Montana" },
        { label: "Nevada", value: "Nevada" },
        { label: "New Jersey", value: "New Jersey" },
        { label: "New Mexico", value: "New Mexico" },
        { label: "New York", value: "New York" },
      ],
    },
  ];

  const productCountry = [
    {
      options: [
        { label: "Select Country...", value: "Select Country" },
        { label: "United States", value: "United States" },
      ],
    },
  ];
  // const [loading, setLoading] = useState(true);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
   
  
  const addressType = [
    {
      options: [
        { label: "Home", value: "home" },
        { label: "Office", value: "office" }
      ],
    },
  ];
  useEffect(() => {
    const loadListAddress = async () => {
      try {
        const response = await fetchSavedAddressList(); 
        console.log('Address API Response:', response); // ✅ Debug logging
        
        if (response && response.status === 200){
          console.log('Address data:', response.data.addresses);
          
          // Check if addresses array exists and has items
          if (response.data && response.data.addresses && Array.isArray(response.data.addresses) && response.data.addresses.length > 0) {
            setSavedAddressList(response.data.addresses);
            setShippingAddressId(response.data.addresses[0].id);
            console.log('First address ID:', response.data.addresses[0].id);
          } else {
            console.log('No addresses found or empty array');
            setSavedAddressList([]);
            // Don't set shippingAddressId if no addresses
          }
        } else {
          console.error('Address API error:', response);
          errornotify(response?.message || 'Failed to load addresses');
        }
      } catch (error) {
        console.error("Error loading address list:", error);
        errornotify("Failed to load address list. Please try again.");
      } finally {
      //  / setLoading(false);
      }
    };
    loadListAddress();
  }, []);


  useEffect(() => {
    const loadCartListData = async () => {
      try {
        const response = await fetchCartList();  
        if (response.status === 200){
          console.log(response.data) 
          setproductList(response.data);
          updateOrderSummary(response.data);
        }
        else{
          errornotify(response.message)
        }
      } catch (error) {
        console.error("Error loading cartlist:", error);
      } finally {
        // setLoading(false);
      }
    };

    loadCartListData();
  }, []);

  const updateOrderSummary = (cartData, shippingMethod = selectedShippingMethod) => {
      if (!cartData || !cartData.cart_items) return;
 
      const newSubTotal = cartData.cart_items.reduce(
          (acc, item) => acc + (item.edition.price * item.quantity), 0
      );
      
      // Round all calculations to 2 decimal places
      const roundedSubTotal = Math.round(newSubTotal * 100) / 100;
      const roundedDiscount = Math.round((cartData.discount ?? 0.15 * roundedSubTotal) * 100) / 100;
      
      // Calculate shipping charge based on selected method
      let shippingCharge = 0;
      if (newSubTotal > 0) {
        if (shippingMethod === "free") {
          shippingCharge = 0;
        } else if (shippingMethod === "express") {
          shippingCharge = 24.99;
        }
      }
      
      const roundedShippingCharge = Math.round(shippingCharge * 100) / 100;
      const roundedTax = Math.round((roundedSubTotal * 0.125) * 100) / 100;  // 12.5% tax rate
      const roundedGrandTotal = Math.round((roundedSubTotal + roundedShippingCharge + roundedTax) * 100) / 100;
      
      setSubTotal(roundedSubTotal);
      setDiscount(roundedDiscount);
      setShippingCharge(roundedShippingCharge);
      setTax(roundedTax);
      setGrandTotal(roundedGrandTotal);
      
      console.log('Order Summary Updated:', {
        subtotal: roundedSubTotal,
        shipping: roundedShippingCharge,
        tax: roundedTax,
        total: roundedGrandTotal,
        method: shippingMethod
      });
  };

  const dispatch = useDispatch();
  const selectLayoutState = (state) => state;
  const checkOutpageData = createSelector(
    selectLayoutState,
    (state) => ({
        user: state.Account.user,
        error: state.Login.error,
        loading: state.Login.loading,
        errorMsg: state.Login.errorMsg,
    })
);
  
  const {
    user, error, loading, errorMsg
} = useSelector(checkOutpageData);

  
  const toggledeletemodal = (addressId = null) => {
    try {
      setDeleteModal(!deletemodal);
      // Store the address ID for deletion if provided
      if (addressId) {
        // You can store this in state if needed for the delete operation
        console.log('Address to delete:', addressId);
      }
    } catch (error) {
      console.error('Error in toggledeletemodal:', error);
    }
  };

  const togglemodal = () => { 
    try {
      setModal(!modal);
    } catch (error) {
      console.error('Error in togglemodal:', error);
    }
  };

  // Wrapper functions for modal toggles to handle React's toggle calls
  const handleDeleteModalToggle = () => {
    try {
      toggledeletemodal();
    } catch (error) {
      console.error('Error in handleDeleteModalToggle:', error);
    }
  };

  const handleAddModalToggle = () => {
    try {
      togglemodal();
    } catch (error) {
      console.error('Error in handleAddModalToggle:', error);
    }
  };
  const handleInputChange = (field, value) => {
    setPersonalData((prevData) => ({
        ...prevData,
        [field]: value,
    }));
    };

    // handle form submit [only 3 fields as demo]
  // const handleSubmitPersonnalInfo = async (e) => {
  //     e.preventDefault();
    
  //     try {
  //       await addCheckOut(personalData);
  //     //   alert("Profile updated successfully!");
  //     } catch (error) {
  //       console.error("Error updating profile:", error);
  //     //   alert("Failed to update profile.");
  //     }
  //   };
  function handleSelectCountry(field, value) {
    setPersonalData((prevData) => ({
        ...prevData,
        [field]: value,
    }));
    setselectedCountry(value);
  }

  function handleSelectState(field, value) {
    setPersonalData((prevData) => ({
        ...prevData,
        [field]: value,
    }));
    setselectedState(value);
  }

  function toggleTab(tab) { 
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];

      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  } 
  function handleSelectAddressCity(field, value) {  
    setAddressCity(value);
  } 

  function handleSelectAddressType(field, value) { 
    setAddressTypeValue(value);
  }
  function handleSelectAddressCountry(field, value) { 
    setAddressCountry(value);
  }
  const handlePaymentMethod = async (field) => {
    setSelectedPaymentMethod(field);
    
    if (field === "stripe") {
      handlePayment()
      // Remove this line - don't set stripe ID immediately
      // setStripeId("111111");
    }
    if (field ==="cash"){
      // For cash payment, we can submit order immediately
      const result = await handleSubmitOrder();
      if (result) {
        // Order submitted successfully, show success page
        setCheckOutStatus(true);
        toggleTab(4); // Show success tab
      } else {
        // Order submission failed
        setCheckOutStatus(false);
        toggleTab(4); // Show failure tab
      }
    }
  }

  const [clientSecret, setClientSecret] = useState(null);
  async function handlePayment() {
    if (paymentLoading) return; // Prevent multiple calls
    
    // Set payment initiated flag
    console.log('Setting paymentInitiated to true');
    setPaymentInitiated(true);
    
    // Validate required data before proceeding
    if (!cartData || !cartData.cart_items || cartData.cart_items.length === 0) {
      errornotify("Your cart is empty. Please add items to proceed.");
      return;
    }
    
    if (!shippingAddressId) {
      errornotify("Please select a shipping address before proceeding with payment.");
      return;
    }
    
    setPaymentLoading(true);
    try {
      const requestData = {
        cart_id: cartData.cart_items[0]?.cart_id,
        address_id: shippingAddressId,
        shipping_method: selectedShippingMethod,
        order_details: {
          subtotal: subTotal,
          discount: dis,
          shipping_charge: charge,
          tax: tax,
          grand_total: grandTotal,
          shipping_method: selectedShippingMethod
        }
      };
      console.log('Sending payment request with data:', requestData); // ✅ Debug logging
      
      console.log('API URL:', `${process.env.REACT_APP_API_URL}/payment/create-checkout-session`); // ✅ Debug URL
      console.log('Auth Token:', sessionStorage.getItem("authToken") ? 'Present' : 'Missing'); // ✅ Debug auth
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/create-checkout-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
        },
        body: JSON.stringify(requestData)
      });
    
      console.log('Response Status:', response.status); // ✅ Debug logging
      console.log('Response Headers:', Object.fromEntries(response.headers.entries())); // ✅ Debug headers
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error Response:', errorText);
        throw new Error(`API Error: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Payment API Response:', data); // ✅ Debug logging
       
      if (data.client_secret) {
        setClientSecret(data.client_secret);
        // Store the payment intent ID for later use
        setStripeId(data.payment_intent_id || data.id);
        setPaymentLoading(false); // ✅ Reset loading state on success
        console.log('Client secret set successfully:', data.client_secret); // ✅ Debug logging
      } else if (data.checkout_url) {
        // If API returns checkout_url instead of client_secret, redirect to Stripe
        console.log('Redirecting to Stripe checkout URL:', data.checkout_url);
        window.location.href = data.checkout_url;
        setPaymentLoading(false);
      } else {
        console.error('API Response:', data); // ✅ Log the response for debugging
        errornotify(`Payment API Error: ${data.message || 'Missing client secret from server'}`);
        setPaymentLoading(false);
      }
    } catch (error) {
      console.error('Error creating payment session:', error);
      errornotify("Failed to create payment session. Please try again.");
      setPaymentLoading(false);
    }
  }

  // Handle Stripe payment completion
  const handleStripePaymentComplete = async (paymentResult) => {
    try {
      setPaymentLoading(false);
      
      // For embedded checkout, use session verification (which we know works!)
      if (clientSecret) {
        // Extract session ID from client secret for embedded checkout
        const sessionId = clientSecret.split('_secret_')[0];
        
        if (sessionId.startsWith('cs_')) {
          // Wait a moment for webhooks to process
          setTimeout(async () => {
            try {
              
              const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/verify/${sessionId}`, {
                headers: {
                  "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
                }
              });
              
              
              if (!response.ok) {
                const errorText = await response.text();
                console.error('Auto-verification API error:', errorText);
                throw new Error(`Verification failed: ${response.status} - ${errorText}`);
              }
              
              const verificationData = await response.json();
              
              if(verificationData.success && verificationData.payment_status === 'paid') {
                // Set all completion states
                setOrderId(verificationData.order_id);
                setCheckOutStatus(true);
                
                // Small delay to ensure state updates, then switch tab
                setTimeout(() => {
                  toggleTab(4);
                }, 100);
              } else {
                console.error('❌ Auto-verification failed:', verificationData);
                setCheckOutStatus(false);
                toggleTab(4);
                errornotify("Payment verification failed. Please contact support.");
              }
            } catch (error) {
              console.error('❌ Error during auto-verification:', error);
              setCheckOutStatus(false);
              toggleTab(4);
              errornotify("Unable to verify payment. Please contact support.");
            }
          }, 3000); // Wait 3 seconds for webhooks
          return;
        }
      }
      
      // Fallback for direct payment intent (if used)
      if (paymentResult.paymentIntent && paymentResult.paymentIntent.status === 'succeeded') {
        console.log('Payment successful, Payment Intent ID:', paymentResult.paymentIntent.id);
        
        setTimeout(async () => {
          try {
            console.log('Verifying payment intent:', paymentResult.paymentIntent.id);
            console.log('Intent verification URL:', `${process.env.REACT_APP_API_URL}/payment/verify-intent/${paymentResult.paymentIntent.id}`);
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/verify-intent/${paymentResult.paymentIntent.id}`, {
              headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
              }
            });
            
            console.log('Intent verification response status:', response.status);
            
            if (!response.ok) {
              const errorText = await response.text();
              console.error('Intent verification API error:', errorText);
              throw new Error(`Intent verification failed: ${response.status} - ${errorText}`);
            }
            
            const verificationData = await response.json();
            console.log('Intent verification data:', verificationData);
            
            if(verificationData.success && verificationData.payment_confirmed) {
              setOrderId(verificationData.order_id);
              setStripeId(paymentResult.paymentIntent.id);
              setCheckOutStatus(true);
              toggleTab(4);
              console.log('Payment verified via intent verification');
            } else {
              setCheckOutStatus(false);
              toggleTab(4);
              errornotify("Payment verification failed. Please contact support.");
            }
          } catch (error) {
            console.error('Error verifying payment intent:', error);
            setCheckOutStatus(false);
            toggleTab(4);
            errornotify("Payment completed but verification failed. Please contact support.");
          }
        }, 3000);
        
      } else {
        // Payment failed or no valid result
        console.error('Payment failed or invalid result:', paymentResult);
        setCheckOutStatus(false);
        toggleTab(4);
        errornotify("Payment failed. Please try again.");
      }
    } catch (error) {
      console.error('Error handling payment completion:', error);
      setPaymentLoading(false);
      setCheckOutStatus(false);
      toggleTab(4);
      errornotify("Payment processing error. Please try again.");
    }
  };

async function reSubmitOrder(orderId) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization":`Bearer ${sessionStorage.getItem("authToken")}` },
      body: JSON.stringify({ 
        order_id: orderId,
        shipping_method: selectedShippingMethod,
        order_details: {
          subtotal: subTotal,
          discount: dis,
          shipping_charge: charge,
          tax: tax,
          grand_total: grandTotal,
          shipping_method: selectedShippingMethod
        }
      })
  }); 
  const session = await response.json(); 
  if (session.session_id) {
  // const stripe = useStripe();
      window.location.href = session.checkout_url; // Redirect to Stripe
    //  stripe.redirectToCheckout({ sessionId: session.id });
  } else {
      errornotify("Payment failed!");
  }
}

  function handleShippingAddress(id){ 
    setShippingAddressId(id)
  }

  // Handle shipping method selection
  const handleShippingMethodChange = (method) => {
    setSelectedShippingMethod(method);
    // Recalculate order summary with new shipping method
    if (cartData) {
      updateOrderSummary(cartData, method);
    }
  };
  const dateFormat = (d) => {
    //let d = new Date()
    return (( d.getFullYear()).toString()+ '-' + d.getMonth() + '-' + d.getDate() );
  };

  const [start_time, setStartTime] = useState(dateFormat(new Date));
  const [end_time, setEndTime] = useState(dateFormat(new Date));
  const startTimeformate = (e) => { 
    const date = e.toString().split(" "); 
    setStartTime(date[4]);
  };
  const endTimeformate = (e) => { 
    const date = e.toString().split(" "); 
    setEndTime(date[4]);
  };
  const [dateRage, setDateRage] = useState(dateFormat(new Date));
  const dateformate = (e) => { 
    let start_date =""; 
    let end_date =""; 
    if(e[0]){
      start_date =dateFormat(e[0]); 
    }
    if(e[1]){
      end_date =dateFormat(e[1]); 
    }
    const dateRage =  [start_date, end_date]
    setDateRage(dateRage);
  };
  
  const addValidation = useFormik({
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      full_name: Yup.string().required("Please Enter full name"),
      address_line1: Yup.string().required("Please Enter a Address Line 1"),
      address_line2: Yup.string().required("Please Enter a Address Line 2"),
      city: Yup.string().required("Please Enter a city"),
      country: Yup.string().required("Please Enter a country"),
      phone_number: Yup.string().required("Please Enter a Phone Number"),
      address_type: Yup.string().required("Please Enter a Address Type"),
      postal_code: Yup.string().required("Please Enter a Postal Code"),
      date_range: Yup.string().required("Please Enter a Date Range"),
      time_range:Yup.string().required("Please Enter a Time Range")
    }),  
  });
  

    const AddAddress = async (values) => {
      try { 
        const hour_start = start_time
        const hour_end = end_time
        const date_start = dateRage[0]
        const date_end = dateRage[1]
        const newAddress = {
          _id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
          full_name: values.full_name,
          address_line1: values.address_line1,
          address_line2: values.address_line2,
          city: selectedAddressCity,
          country: selectedAddressCountry,
          phone_number: values.phone_number,
          address_type: selectedAddressType,
          postal_code: values.postal_code,
          available_hours:[
            {
              "date_start": date_start,
              "date_end": date_end,
              "hour_start": hour_start,
              "hour_end": hour_end
            }
          ]
        };
    
        // Make API call with error handling
        const response = await addAddress(newAddress); 
        
        // Check if response exists and has expected structure
        if (!response) {
          errornotify('No response received from server');
        } 
    
        // Handle successful response
        if (response.status==200) {
          successnotify("address added successfully"); 
          togglemodal();  
          const addressResponse = await fetchSavedAddressList(); 
          if (addressResponse && addressResponse.status === 200){
            console.log('Updated address data:', addressResponse.data.addresses);
            
            if (addressResponse.data && addressResponse.data.addresses && Array.isArray(addressResponse.data.addresses) && addressResponse.data.addresses.length > 0) {
              setSavedAddressList(addressResponse.data.addresses);
              setShippingAddressId(addressResponse.data.addresses[0].id);
            } else {
              setSavedAddressList([]);
            }
          } else {
            errornotify(addressResponse?.message || 'Failed to reload addresses');
          }
          // Optionally reset form or redirect
          // validation.resetForm();
          // navigate('/products'); // If you want to redirect after success
        } else {
          // Handle API error with message
          errornotify(response.message || "Failed to add address. Please try again.");
        }
    
      } catch (err) {
        console.error('Submission failed:', err);
        
        // User-friendly error message
        errornotify(
          err.response?.message || 
          err.message || 
          'Failed to add address. Please check your connection and try again.'
        );
      }
    };
  
    const editAddress = (id) => { 
      // Reset form values properly using Formik's setValues method
      addValidation.setValues({});
      console.log('savedAddressList',id, savedAddressList.find((a) => a.id === id).available_hours[0]);
      const startDate = new Date(savedAddressList.find((a) => a.id === id).available_hours[0].date_start)
      const endDate = new Date(savedAddressList.find((a) => a.id === id).available_hours[0].date_end)
      const dateRage =  [startDate, endDate]
      addValidation.setValues({
        full_name: savedAddressList.find((a) => a.id === id).full_name,
        address_line1: savedAddressList.find((a) => a.id === id).address_line1,
        address_line2: savedAddressList.find((a) => a.id === id).address_line2,
        postal_code: savedAddressList.find((a) => a.id === id).postal_code,
        phone_number: savedAddressList.find((a) => a.id === id).phone_number,
        start_time: savedAddressList.find((a) => a.id === id).available_hours[0].hour_start,
        end_time: savedAddressList.find((a) => a.id === id).available_hours[0].hour_end,
        date_range: dateRage,
        // end_date: savedAddressList.find((a) => a._id === id).end_date,
        address_type: savedAddressList.find((a) => a.id === id).address_type
      });
      setStartTime(savedAddressList.find((a) => a.id === id).available_hours[0].hour_start);
      setEndTime(savedAddressList.find((a) => a.id === id).available_hours[0].hour_end);
      setDateRage([savedAddressList.find((a) => a.id === id).available_hours[0].date_start,savedAddressList.find((a) => a.id === id).available_hours[0].date_end])
      setAddressTypeValue(savedAddressList.find((a) => a.id === id).type);
      setAddressCity(savedAddressList.find((a) => a.id === id).city);
      setAddressCountry(savedAddressList.find((a) => a.id === id).country);
      togglemodal();
  
    };

     
    const AddBillingInfo = async (values) => {
      try {  
        const billData = {
          _id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          city: selectedState,
          country: selectedCountry,
          phone: values.phone,
          zip: values.zip,
          address: values.address
        };
         
        // Make API call with error handling
        const response = await addAddress(billData); 
         
        // Check if response exists and has expected structure
        if (!response) {
          errornotify('No response received from server');
        }
    
         
        // Handle successful response
        if (response.status==200) {
          successnotify("billing info added successfully");
          setBillingAddressId(response.data.id)
          toggleTab(activeTab+1);
          // Optionally reset form or redirect
          // validation.resetForm();
          // navigate('/products'); // If you want to redirect after success
        } else {
          // Handle API error with message
          errornotify(response.message || "Failed to add billing info . Please try again.");
        }
    
      } catch (err) {
        console.error('Submission failed:', err);
         
        // User-friendly error message
        errornotify(
          err.response?.message || 
          err.message || 
          'Failed to add billing info . Please check your connection and try again.'
        );
      }
    };

    const  handleSubmitOrder =async() => {
      try { 
        // Check if Stripe payment is required but not completed
        if (clientSecret && !stripeId) {
          errornotify("Please complete your Stripe payment before submitting the order.");
          return false;
        }

        const response = await submitOrder({ 
          cart_id: cartData.cart_items.length>0?cartData.cart_items[0].cart_id:null, 
          billing_address_id: billingAddressId,
          shipping_address_id:shippingAddressId,
          stripe_id:stripeId,
          shipping_method: selectedShippingMethod,
          order_details: {
            subtotal: subTotal,
            discount: dis,
            shipping_charge: charge,
            tax: tax,
            grand_total: grandTotal,
            shipping_method: selectedShippingMethod
          }
        });
        
        console.log('Checkout - Full order submission response:', response);
        if (response.success) {
          // Store the order ID from the response
          const orderIdFromResponse = response.order?.id;
          console.log('Order created successfully with ID:', orderIdFromResponse);
          
          // Set the order ID state
          setOrderId(orderIdFromResponse);
          
          // For now, use order ID as payment ID if no separate payment ID exists
          setPaymentId(orderIdFromResponse);
          setCheckOutStatus(true);
          
          // Don't auto-navigate here - let the caller handle navigation
          // toggleTab(activeTab + 1); // Move to confirmation step
          
          return true; // Return success status
        } else {
          setCheckOutStatus(false);
          errornotify(response.message || "Order submission failed. Please try again.");
          return false; // Return failure status
        }
      } catch (error) { 
        errornotify("Something went wrong. Please try again later.");
        setCheckOutStatus(false);
        return false; // Return failure status
      }
    }
  document.title="Checkout | SeedNations";
  // Show loading state while validating cart
  if (cartLoading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Validating your cart...</p>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  // Show empty cart message if no items
  if (!hasItems) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div className="text-center py-5">
              <div className="avatar-md mx-auto my-3">
                <div className="avatar-title bg-warning-subtle text-warning fs-36 rounded-circle">
                  <i className='bx bx-cart'></i>
                </div>
              </div>
              <h5 className="mb-3">Your Cart is Empty!</h5>
              <p className="text-muted mb-4">You need items in your cart to proceed with checkout.</p>
              <Link to="/product-list" className="btn btn-success w-md mb-3 me-2">Shop Now</Link>
              <Link to="/my-cart" className="btn btn-outline-secondary w-md mb-3">View Cart</Link>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <ZendeskWidget />
        <Container fluid>
          <ToastContainer />
          <BreadCrumb title="Checkout" pageTitle="Ecommerce" />

          <Row>
            <Col xl="8">
              <Card>
                <CardBody className="checkout-tab">
                    <div className="step-arrow-nav mt-n3 mx-n3 mb-3">
                      <Nav
                        className="nav-pills nav-justified custom-nav"
                        role="tablist"
                      >
                        <NavItem role="presentation">
                          <NavLink href="#"
                            className={classnames({ active: activeTab === 1, done: (activeTab <= 4 && activeTab >= 0) }, "p-3 fs-15")}
                            onClick={() => { toggleTab(1); }}
                          >
                            <i className="ri-user-2-line fs-16 p-2 bg-primary-subtle text-primary rounded-circle align-middle me-2"></i>
                            Personal Info
                          </NavLink>
                        </NavItem>
                        <NavItem role="presentation">
                          <NavLink href="#"
                            className={classnames({ active: activeTab === 2, done: activeTab <= 4 && activeTab > 1 }, "p-3 fs-15")}
                            onClick={() => { toggleTab(2); }}
                          >
                            <i className="ri-truck-line fs-16 p-2 bg-primary-subtle text-primary rounded-circle align-middle me-2"></i>
                            Shipping Info
                          </NavLink>
                        </NavItem>
                        <NavItem role="presentation">
                          <NavLink href="#"
                            className={classnames({ active: activeTab === 3, done: activeTab <= 4 && activeTab > 2 }, "p-3 fs-15")}
                            onClick={() => { toggleTab(3); }}
                          >
                            <i className="ri-bank-card-line fs-16 p-2 bg-primary-subtle text-primary rounded-circle align-middle me-2"></i>
                            Payment Info
                          </NavLink>
                        </NavItem>
                        <NavItem role="presentation">
                          <NavLink href="#"
                            className={classnames({ active: activeTab === 4, done: activeTab <= 4 && activeTab > 3 }, "p-3 fs-15")}
                            // onClick={() => { toggleTab(4); }}
                          >
                            <i className="ri-checkbox-circle-line fs-16 p-2 bg-primary-subtle text-primary rounded-circle align-middle me-2"></i>
                            Finish
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={1} id="pills-bill-info">
                        <div>
                          <h5 className="mb-1">Billing Information</h5>
                          <p className="text-muted mb-4">
                            Please fill all information below
                          </p>
                          
                          {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                        </div> 
                        <div>
                          <Row>
                            <Col sm={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="billinginfo-firstName"
                                  className="form-label"
                                >
                                  First Name
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="first_name"
                                  onChange={(e) => handleInputChange("first_name", e.target.value)}
                                  value={personalData.first_name || ""} 
                                  id="billinginfo-firstName"
                                  placeholder="Enter first name"
                                /> 
                              </div>
                            </Col>

                            <Col sm={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="billinginfo-lastName"
                                  className="form-label"
                                >
                                  Last Name
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control" 
                                  id="billinginfo-lastName"
                                  name="last_name"
                                  placeholder="Enter last name"
                                  onChange={(e) => handleInputChange("last_name", e.target.value)}
                                  value={personalData.last_name || ""} 
                                /> 
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="billinginfo-email"
                                  className="form-label"
                                >
                                  Email
                                  <span className="text-muted">(Optional)</span>
                                </Label>
                                <Input
                                  type="email"
                                  name="email"
                                  className="form-control" 
                                  id="billinginfo-email"
                                  placeholder="Enter email"
                                  onChange={(e) => handleInputChange("email", e.target.value)}
                                  value={personalData.email || ""} 
                                /> 
                              </div>
                            </Col>

                            <Col sm={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="billinginfo-phone"
                                  className="form-label"
                                >
                                  Phone
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="billinginfo-phone"
                                  placeholder="Enter phone no."
                                  name="phone"
                                  onChange={(e) => handleInputChange("phone", e.target.value)}
                                  value={personalData.phone || ""} 
                                /> 
                              </div>
                            </Col>
                          </Row>

                          <div className="mb-3">
                            <Label
                              htmlFor="billinginfo-address"
                              className="form-label"
                            >
                              Address
                            </Label>
                            <textarea
                              className="form-control"
                              id="billinginfo-address"
                              placeholder="Enter address"
                              rows="3"
                              name="address"
                              onChange={(e) => handleInputChange("address", e.target.value)}
                              value={personalData.address || ""} >
                             </textarea> 
                          </div>

                          <Row>
                            <Col md={4}>
                              <div className="mb-3">
                                <Label htmlFor="country" className="form-label">
                                  Country
                                </Label>
                                <Select
                                  value={selectedCountry}
                                  onChange={(e) => {
                                    handleSelectCountry("country",e.value);
                                  }}
                                  options={productCountry}
                                  id="country"
                                  name="country"  ></Select>  
                              </div>
                            </Col>

                            <Col md={4}>
                              <div className="mb-3">
                                <Label htmlFor="state" className="form-label">
                                  State
                                </Label>
                                <Select
                                  id="state"
                                  value={selectedState}
                                  onChange={(e) => {
                                    handleSelectState("selectedState",e.value);
                                  }}
                                  options={productState}
                                ></Select>
                              </div>
                            </Col>

                            <Col md={4}>
                              <div className="mb-3">
                                <Label htmlFor="zip" className="form-label">
                                  Zip Code
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="zip"
                                  placeholder="Enter zip code"
                                  name="zip"
                                  onChange={(e) => handleInputChange("zip", e.target.value)}
                                  value={personalData.zip || ""} 
                                />
                              </div>
                            </Col>
                          </Row>

                          <div className="d-flex align-items-start gap-3 mt-3">
                            <button
                              type="submit"
                              className="btn btn-primary btn-label right ms-auto nexttab"
                              // onClick={() => { AddBillingInfo(personalData); }}
                            onClick={() => {
                              toggleTab(activeTab + 1);
                            }} 
                            >
                              <i className="ri-truck-line label-icon align-middle fs-16 ms-2"></i>
                              Proceed to Shipping
                            </button>
                          </div>
                        </div> 
                      </TabPane>

                      <TabPane tabId={2}>
                        <div>
                          <h5 className="mb-1">Shipping Information</h5>
                          <p className="text-muted mb-4">
                            Please fill all information below
                          </p>
                        </div>

                        <div className="mt-4">
                          <div className="d-flex align-items-center mb-2">
                            <div className="flex-grow-1">
                              <h5 className="fs-14 mb-0">Saved Address</h5>
                            </div>
                            <div className="flex-shrink-0">
                              <button
                                type="button"
                                className="btn btn-sm btn-primary mb-3"
                                onClick={()=>togglemodal()}
                              >
                                Add Address
                              </button>
                            </div>
                          </div>
                          <Row className="gy-3">
                            
                        {savedAddressList && savedAddressList.length > 0 ? savedAddressList.map((addressItem, key) => (
                            <Col lg={4} sm={6}>
                              <div className="form-check card-radio">
                                <Input
                                  id={`shippingAddress${addressItem.id}`}
                                  name="shippingAddress"
                                  type="radio"
                                  className="form-check-input" 
                                  value={addressItem.id}
                                  onChange={(e) => { 
                                    handleShippingAddress(e.target.value);
                                  }}  
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor={`shippingAddress${addressItem.id}`}
                                >
                                  <span className="mb-4 fw-semibold d-block text-muted text-uppercase">
                                    {addressItem.full_name}
                                  </span>
                                  <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                    {addressItem.address_line1}
                                  </span>
                                  <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                    {addressItem.address_line2}
                                  </span>
                                  <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                    {addressItem.city}, {addressItem.state}, {addressItem.country}-{addressItem.postal_code}
                                  </span>
                                  <span className="text-muted fw-normal d-block">
                                    {addressItem.phone_number}
                                  </span>
                                </Label>
                              </div>
                              <div className="d-flex flex-wrap p-2 py-1 bg-light rounded-bottom border mt-n1">
                                <div>
                                  <Link 
                                    className="d-block text-dark p-1 px-2"
                                    // onClick={editAddress(addressItem.id)}
                                  >
                                    <i className="ri-pencil-fill text-muted align-bottom me-1"></i>
                                    Edit
                                  </Link>
                                </div>
                                <div>
                                  <Link
                                    to="#"
                                    className="d-block text-dark p-1 px-2"
                                    onClick={()=>toggledeletemodal(addressItem.id)}
                                  >
                                    <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i>
                                    Remove
                                  </Link>
                                </div>
                              </div>
                            </Col>
                            )) : (
                              <Col xs={12}>
                                <div className="text-center py-4">
                                  <div className="mb-3">
                                    <i className="ri-map-pin-line display-4 text-muted"></i>
                                  </div>
                                  <h5 className="text-muted">No Saved Addresses</h5>
                                  <p className="text-muted mb-3">
                                    You don't have any saved addresses yet. Please add an address to continue with checkout.
                                  </p>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => togglemodal()}
                                  >
                                    <i className="ri-add-line me-1"></i>
                                    Add Address
                                  </button>
                                </div>
                              </Col>
                            )}
                            {/* <Col lg={4} sm={6}>
                              <div className="form-check card-radio">
                                <Input
                                  id="shippingAddress02"
                                  name="shippingAddress"
                                  type="radio"
                                  className="form-check-input"
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="shippingAddress02"
                                >
                                  <span className="mb-4 fw-semibold d-block text-muted text-uppercase">
                                    Office Address
                                  </span>

                                  <span className="fs-14 mb-2 d-block">
                                    James Honda
                                  </span>
                                  <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                    1246 Virgil Street Pensacola, FL 32501
                                  </span>
                                  <span className="text-muted fw-normal d-block">
                                    Mo. 012-345-6789
                                  </span>
                                </Label>
                              </div>
                              <div className="d-flex flex-wrap p-2 py-1 bg-light rounded-bottom border mt-n1">
                                <div>
                                  <Link
                                    to="#"
                                    className="d-block text-dark p-1 px-2"
                                    onClick={togglemodal}
                                  >
                                    <i className="ri-pencil-fill text-muted align-bottom me-1"></i>
                                    Edit
                                  </Link>
                                </div>
                                <div>
                                  <Link
                                    to="#"
                                    className="d-block text-dark p-1 px-2"
                                    onClick={toggledeletemodal}
                                  >
                                    <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i>
                                    Remove
                                  </Link>
                                </div>
                              </div>
                            </Col> */}
                          </Row>

                          <div className="mt-4">
                            <h5 className="fs-14 mb-3">Shipping Method</h5>

                            <Row className="g-4">
                              <Col lg={6}>
                                <div className="form-check card-radio">
                                  <Input
                                    id="shippingMethod01"
                                    name="shippingMethod"
                                    type="radio"
                                    className="form-check-input"
                                    checked={selectedShippingMethod === "free"}
                                    onChange={() => handleShippingMethodChange("free")}
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="shippingMethod01"
                                  >
                                    <span className="fs-20 float-end mt-2 text-wrap d-block fw-semibold">
                                      Free
                                    </span>
                                    <span className="fs-14 mb-1 text-wrap d-block">
                                      Free Delivery
                                    </span>
                                    <span className="text-muted fw-normal text-wrap d-block">
                                      Expected Delivery 3 to 5 Days
                                    </span>
                                  </Label>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="form-check card-radio">
                                  <Input
                                    id="shippingMethod02"
                                    name="shippingMethod"
                                    type="radio"
                                    className="form-check-input"
                                    checked={selectedShippingMethod === "express"}
                                    onChange={() => handleShippingMethodChange("express")}
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor="shippingMethod02"
                                  >
                                    <span className="fs-20 float-end mt-2 text-wrap d-block fw-semibold">
                                      $24.99
                                    </span>
                                    <span className="fs-14 mb-1 text-wrap d-block">
                                      Express Delivery
                                    </span>
                                    <span className="text-muted fw-normal text-wrap d-block">
                                      Delivery within 24hrs.
                                    </span>
                                  </Label>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>

                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-light btn-label previestab"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                            Back to Personal Info
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-label right ms-auto nexttab"
                            onClick={() => {
                              toggleTab(activeTab + 1);
                            }}
                          >
                            <i className="ri-bank-card-line label-icon align-middle fs-16 ms-2"></i>
                            Continue to Payment
                          </button>
                        </div>
                      </TabPane>

                      <TabPane tabId={3}>
                        <div>
                          <h5 className="mb-1">Payment Selection</h5>
                          <p className="text-muted mb-4">
                            Please select and enter your billing information
                          </p>
                        </div>

                        <Row className="g-4">
                          <Col lg={4} sm={6}>
                            <div>
                              <div className="form-check card-radio">
                                <Input
                                  id="paymentMethod01"
                                  name="paymentMethod"
                                  type="radio"
                                  className="form-check-input"  
                                  onChange={(e) => {
                                    handlePaymentMethod("stripe");
                                  }}
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="paymentMethod01"
                                >
                                  <span className="fs-16 text-muted me-2">
                                    <i className="ri-paypal-fill align-bottom"></i>
                                  </span>
                                  <span className="fs-14 text-wrap">
                                    {paymentLoading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                        </span>
                                        Processing...
                                      </>
                                    ) : (
                                      "Payment with Stripe"
                                    )}
                                  </span>
                                </Label>
                              </div>
                            </div>
                          </Col> 

                          <Col lg={4} sm={6}>
                            <div>
                              <div className="form-check card-radio">
                                <Input
                                  id="paymentMethod03"
                                  name="paymentMethod"
                                  type="radio"
                                  className="form-check-input"
                                  onChange={(e) => {
                                    handlePaymentMethod("cash");
                                  }}
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="paymentMethod03"
                                >
                                  <span className="fs-16 text-muted me-2">
                                    <i className="ri-money-dollar-box-fill align-bottom"></i>
                                  </span>
                                  <span className="fs-14 text-wrap">
                                    Cash on Delivery
                                  </span>
                                </Label>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {/* Stripe Payment Section - Embedded within the payment tab */}
                        {selectedPaymentMethod === "stripe" && clientSecret && (
                          <div className="mt-4">
                            <div className="alert alert-info mb-3">
                              <i className="ri-information-line me-2"></i>
                              <strong>Complete Your Payment:</strong> Please complete your payment using the form below. Your order will be submitted automatically once payment is confirmed.
                            </div>
                            <Card className="border shadow-none">
                              <CardBody>
                                <EmbeddedCheckoutProvider
                                  stripe={stripePromise}
                                  options={{ clientSecret }}
                                >
                                  <EmbeddedCheckout 
                                    onComplete={(result) => {
                                      console.log('🎉 Stripe onComplete triggered with result:', result);
                                      console.log('Result type:', typeof result);
                                      console.log('Result keys:', Object.keys(result || {}));
                                      handleStripePaymentComplete(result);
                                    }}
                                    onReady={() => {
                                      console.log('Stripe EmbeddedCheckout is ready');
                                    }}
                                    onError={(error) => {
                                      console.error('❌ Stripe EmbeddedCheckout error:', error);
                                    }}
                                  />
                                </EmbeddedCheckoutProvider>
                              </CardBody>
                            </Card>
                            
                            {/* Payment completion button */}
                            <div className="mt-3">
                              <div className="alert alert-success">
                                <i className="ri-check-line me-2"></i>
                                <strong>Payment Completed?</strong> Once you see "Thanks for your payment" above, click below to continue.
                              </div>
                              <button 
                                type="button" 
                                className="btn btn-success btn-lg w-100"
                                onClick={() => {
                                  handleStripePaymentComplete({
                                    paymentIntent: { id: 'manual_completion', status: 'succeeded' }
                                  });
                                }}
                              >
                                <i className="ri-arrow-right-line me-2"></i>
                                Continue to Order Confirmation
                              </button>
                            </div>
                            
                          </div>
                        )}

                        {/* Show message when Stripe is selected but clientSecret is not ready */}
                        {selectedPaymentMethod === "stripe" && !clientSecret && (
                          <div className="mt-4">
                            <div className="alert alert-warning">
                              <i className="ri-loader-4-line me-2"></i>
                              <strong>Loading Payment Form:</strong> Please wait while we prepare your payment form...
                            </div>
                          </div>
                        )}

                        <div className="d-flex align-items-start gap-3 mt-4">
                          <button
                            type="button"
                            className="btn btn-light btn-label previestab"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                            Back to Shipping
                          </button>
                            {/* Complete Order button - only show for cash payment */}
                          {selectedPaymentMethod === "cash" && (
                            <button
                              type="button"
                              className="btn btn-primary btn-label right ms-auto nexttab"
                              onClick={async () => {
                                const result = await handleSubmitOrder();
                                if (result) {
                                  setCheckOutStatus(true);
                                  toggleTab(4); // Show success tab
                                } else {
                                  setCheckOutStatus(false);
                                  toggleTab(4); // Show failure tab
                                }
                              }} 
                            >
                              <i className="ri-shopping-basket-line label-icon align-middle fs-16 ms-2"></i>
                              Complete Order
                            </button>
                          )}
                        </div>
                      </TabPane>

                      <TabPane tabId={4} id="pills-finish">
                        {checkoutStatus ? (
                          <div className="text-center py-5">
                            <div className="mb-4">
                              <lord-icon
                                src="https://cdn.lordicon.com/lupuorrc.json"
                                trigger="loop"
                                colors="primary:#25a0e2,secondary:#00bd9d"
                                style={{ width: "120px", height: "120px" }}
                              ></lord-icon>
                            </div>
                            <h5>Thank you ! Your Order is Completed !</h5>
                            <p className="text-muted">
                              You will receive an order confirmation email with
                              details of your order.
                            </p>

                            <h3 className="fw-semibold">
                              Order ID:{" "}
                              <Link
                                to={"/order-detail?orderId=" + orderId}
                                className="text-decoration-underline"
                              >
                                {orderId || "Loading..."}
                              </Link>
                            </h3>
                            

                            
                            {/* Success actions */}
                            <div className="mt-4">
                              <Link to="/my-cart" className="btn btn-outline-secondary btn-label me-2">
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                Back to Cart
                              </Link>
                              <Link to="/product-list" className="btn btn-primary btn-label">
                                <i className="ri-shopping-cart-line label-icon align-middle fs-16 me-2"></i>
                                Continue Shopping
                              </Link>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center py-5">
                            <div className="mb-4">
                              <lord-icon
                                src="https://cdn.lordicon.com/tdrtiskw.json"
                                trigger="loop"
                                colors="primary:#dc3545,secondary:#6c757d"
                                style={{ width: "120px", height: "120px" }}
                              ></lord-icon>
                            </div>
                            <h5>Sorry ! Your Order submission failed !</h5>
                            <p className="text-muted">
                              Please try again.
                            </p>
                            
                            {/* Failure actions */}
                            <div className="mt-4">
                              <button
                                type="button"
                                className="btn btn-danger btn-label me-2"
                                onClick={() => {
                                  toggleTab(activeTab - 1); // Go back to previous step
                                }}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                Go Back
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary btn-label"
                                onClick={async () => {
                                  const result = await handleSubmitOrder(); // Try submitting again
                                  if (result) {
                                    setCheckOutStatus(true);
                                    // Page will automatically show success state
                                  } else {
                                    setCheckOutStatus(false);
                                    // Page will automatically show failure state
                                  }
                                }}
                              >
                                <i className="ri-refresh-line label-icon align-middle fs-16 me-2"></i>
                                Try Again
                              </button>
                            </div>
                          </div>
                        )}
                        
                      </TabPane>
                    </TabContent>
                </CardBody>
              </Card>

              {/* {stripeUrl? <Card>
                <CardBody className="d-flex flex-column" style={{ minHeight: 800 }}>
                  <div className={`position-absolute w-100 h-100 ${iframeLoaded ? 'd-none' : 'd-flex'} align-items-center justify-content-center`}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  {stripeUrl}
                  <iframe 
                    src={stripeUrl}
                    style={{ 
                      flex: 1,
                      border: "none",
                      display: iframeLoaded ? 'block' : 'none'
                    }}
                    frameBorder="0"
                    title="payment-gateway"
                    onLoad={() => {
                      console.log('Iframe content loaded');
                      setIframeLoaded(true);
                    }}
                    onError={(e) => {
                      console.error('Iframe error:', e);
                      setIframeLoaded(false);
                    }}
                  />
                </CardBody>
              </Card> : null} */}
            </Col>

            <Col xl={4}>
              <Card>
                <CardHeader>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">Order Summary</h5>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive table-card">
                    <table className="table table-borderless align-middle mb-0">
                      <thead className="table-light text-muted">
                        <tr>
                          <th style={{ width: "90px" }} scope="col">
                            Product
                          </th>
                          <th scope="col">Product Info</th>
                          <th scope="col" className="text-end">
                            Price
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {cartData?cartData.cart_items?cartData.cart_items.map((cartItem, key) => (
                          <React.Fragment key={cartItem.id}>
                            <tr>
                              <td>
                                <div className="avatar-md bg-light rounded p-1">
                                  <img
                                    src={
                                      cartItem.edition && 
                                      cartItem.edition.images && 
                                      cartItem.edition.images.length > 0
                                          ? baseURL + "/file/product/image/" + cartItem.edition.images[0].image_url
                                          : baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"
                                    }
                                    alt={cartItem.product?.name || "Product"}
                                    className="img-fluid d-block"
                                    onError={(e) => {
                                        e.target.src = baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp";
                                        e.target.onerror = null; // Prevent infinite loop
                                    }}
                                  />
                                </div>
                              </td>
                              <td>
                                <h5 className="fs-14">
                                  <Link
                                    to="/apps-ecommerce-product-details"
                                    className="text-dark"
                                  >
                                    {cartItem.product?.name || "Product"}-{cartItem.edition?.edition_name || "Edition"}
                                  </Link>
                                </h5>
                                                                  <p className="text-muted mb-0">
                                    $ {(cartItem.edition?.price || 0).toFixed(2)} x {cartItem.quantity}
                                  </p>
                              </td>
                              <td className="text-end">$ {Math.round(cartItem.total * 100) / 100}</td>
                            </tr>
                          </React.Fragment>
                        )):"":""}

                        <tr>
                          <td className="fw-semibold" colSpan="2">
                            Sub Total :
                          </td>
                          <td className="fw-semibold text-end">$ {subTotal.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            Discount{" "}
                            <span className="text-muted">(SN15)</span>:{" "}
                          </td>
                          <td className="text-end">- $ {dis.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td colSpan="2">Shipping Charge :</td>
                          <td className="text-end">$ {charge.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td colSpan="2">Estimated Tax (12.5%): </td>
                          <td className="text-end">$ {tax.toFixed(2)}</td>
                        </tr>
                        <tr className="table-active">
                          <th colSpan="2">Total (USD) :</th>
                          <td className="text-end">
                            <span className="fw-semibold">${grandTotal.toFixed(2)}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* modal Delete Address */}
      <Modal
        isOpen={deletemodal}
        role="dialog"
        autoFocus={true}
        centered
        id="removeItemModal"
        toggle={handleDeleteModalToggle}
      >
        <ModalHeader toggle={handleDeleteModalToggle}>
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 text-center">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#FFBC0A,secondary:#f06548"
              style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Are you Sure ?</h4>
              <p className="text-muted mx-4 mb-0">
                Are you Sure You want to Remove this Address ?
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              onClick={handleDeleteModalToggle}
            >
              Close
            </button>
            <button type="button" className="btn w-sm btn-danger" onClick={handleDeleteModalToggle}>
              Yes, Delete It!
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* modal Add Address */}
      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered
        id="addAddressModal"
        toggle={handleAddModalToggle}
      >
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          console.log('onsubmit');
           
          console.log(addValidation.values);
          AddAddress(addValidation.values);
          return false;
        }}>
        <ModalHeader
          toggle={handleAddModalToggle}
        >
            Address
        </ModalHeader>
        <ModalBody> 
            <div className="mb-3">
              <Label for="addaddress-Name" className="form-label">
                Name
              </Label>
              <Input
                type="text"
                className="form-control"
                id="addaddress-Name"
                placeholder="Enter Name" 
                name="full_name"
                value={addValidation.values.full_name || ""}
                onBlur={addValidation.handleBlur}
                onChange={addValidation.handleChange}
                invalid={addValidation.errors.full_name && addValidation.touched.full_name ? true : false}
              />
              {addValidation.errors.full_name && addValidation.touched.full_name ? (
                <FormFeedback type="invalid">{addValidation.errors.full_name}</FormFeedback>
              ) : null} 
            </div>

            <div className="mb-3">
              <Label htmlFor="country" className="form-label">
                Country
              </Label>
              <Select
                value={addValidation.values.country}
                onChange={(e) => {
                  handleSelectAddressCountry("country",e.value);
                }}  
                options={productCountry}
                name="country"
                classNamePrefix="select2-selection form-select"
              />  
            </div> 

            <div className="mb-3">
              <Label htmlFor="state" className="form-label">
                City
              </Label>
              
              <Select
                value={addValidation.values.city}
                onChange={(e) => {
                  handleSelectAddressCity("city",e.value);
                }} 
                options={productState}
                name="city"
                classNamePrefix="select2-selection form-select"
              />   
            </div>
            <div className="mb-3">
              <Label for="addaddress-textarea" className="form-label">
                Address Line1
              </Label>
              <textarea
                className="form-control"
                id="addaddress-textarea"
                placeholder="Enter Address"
                rows="2"
                name="address_line1"
                value={addValidation.values.address_line1 || ""}
                onBlur={addValidation.handleBlur}
                onChange={addValidation.handleChange}
                invalid={addValidation.errors.address_line1 && addValidation.touched.address_line1 ? true : false}
              >
              {addValidation.errors.address_line1 && addValidation.touched.address_line1 ? (
                <FormFeedback type="invalid">{addValidation.errors.address_line1}</FormFeedback>
              ) : null} 
              </textarea>
            </div>

            <div className="mb-3">
              <Label for="addaddress-textarea" className="form-label">
                Address Line2
              </Label>
              <textarea
                className="form-control"
                id="addaddress-textarea"
                placeholder="Enter Address"
                rows="2"
                name="address_line2"
                value={addValidation.values.address_line2 || ""}
                onBlur={addValidation.handleBlur}
                onChange={addValidation.handleChange}
                invalid={addValidation.errors.address_line2 && addValidation.touched.address_line2 ? true : false}
              >
              {addValidation.errors.address_line2 && addValidation.touched.address_line2 ? (
                <FormFeedback type="invalid">{addValidation.errors.address_line2}</FormFeedback>
              ) : null} 
              </textarea>
            </div>

            <div className="mb-3">
              <Label for="addaddress-Name" className="form-label">
              postal code
              </Label>
              <Input
                type="text"
                className="form-control"
                id="addaddress-Name"
                placeholder="Enter Name" 
                name="postal_code"
                value={addValidation.values.postal_code || ""}
                onBlur={addValidation.handleBlur}
                onChange={addValidation.handleChange}
                invalid={addValidation.errors.postal_code && addValidation.touched.postal_code ? true : false}
              />
              {addValidation.errors.postal_code && addValidation.touched.postal_code ? (
                <FormFeedback type="invalid">{addValidation.errors.postal_code}</FormFeedback>
              ) : null} 
            </div>
            <div className="mb-3">
              <Label for="addaddress-Name" className="form-label">
                Phone
              </Label>
              <Input
                type="text"
                className="form-control"
                id="addaddress-Name"
                placeholder="Enter Phone No."
                name="phone_number"
                value={addValidation.values.phone_number || ""}
                onBlur={addValidation.handleBlur}
                onChange={addValidation.handleChange}
                invalid={addValidation.errors.phone_number && addValidation.touched.phone_number ? true : false}
              />
              {addValidation.errors.phone_number && addValidation.touched.phone_number ? (
                <FormFeedback type="invalid">{addValidation.errors.phone_number}</FormFeedback>
              ) : null} 
            </div>

            <div className="mb-3">
              <Label for="addaddress-Name" className="form-label">
              date Range
              </Label>
              <Flatpickr
                type="text"
                className="form-control"
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d"
                }}
                id="addaddress-Name"
                placeholder="Enter Phone No."
                name="date_range"
                value={addValidation.values.date_range || ""} 
                onChange={(e) =>
                  dateformate(e)
                }
                invalid={addValidation.errors.date_range && addValidation.touched.date_range ? true : false}
              />
              {addValidation.errors.date_range && addValidation.touched.date_range ? (
                <FormFeedback type="invalid">{addValidation.errors.date_range}</FormFeedback>
              ) : null} 
            </div>

            <div className="mb-3">
              <Label for="addaddress-Name" className="form-label" 
                style={{ display: "block" }}>
              Time Range
              </Label>
              <Flatpickr
                type="text"
                className="form-control"
                style={{ width: "40%",display: "inline-block" }}
                options={{ 
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: "H:i",
                  time_24hr: true
                }}
                id="addaddress-Name"
                placeholder="Enter Start Time."
                name="time_range"
                value={addValidation.values.start_time} 
                onChange={(e) =>
                  startTimeformate(e)
                }
                invalid={addValidation.errors.start_time && addValidation.touched.start_time ? true : false}
              />
              {addValidation.errors.start_time && addValidation.touched.start_time ? (
                <FormFeedback type="invalid">{addValidation.errors.start_time}</FormFeedback>
              ) : null}  
              &nbsp; &nbsp; ——    &nbsp; &nbsp;
              <Flatpickr
                type="text"
                className="form-control"
                style={{ width: "40%",display: "inline-block" }}
                options={{ 
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: "H:i",
                  time_24hr: true
                }}
                id="addaddress-Name"
                placeholder="Enter End Time."
                name="time_range"
                value={addValidation.values.end_time} 
                onChange={(e) =>
                  endTimeformate(e)
                }
                invalid={addValidation.errors.end_time && addValidation.touched.end_time ? true : false}
              />
              {addValidation.errors.vs && addValidation.touched.end_time ? (
                <FormFeedback type="invalid">{addValidation.errors.end_time}</FormFeedback>
              ) : null} 
            </div>

            <div className="mb-3">
              <Label for="state" className="form-label">
                Address Type
              </Label>
              <Select
                value={addValidation.values.address_type}
                onChange={(e) => {
                  handleSelectAddressType("address_type",e.value);
                }}   
                options={addressType}
                name="choices-address-type-input"
                classNamePrefix="select2-selection form-select"
              /> 
            </div> 
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-light"
            onClick={handleAddModalToggle}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-success" 
          >
            Save
          </button>
        </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default CheckOut;
